/*
 * @Author: M.D.
 * @Date: 2019-12-31 17:32:44
 * @LastEditors: M.D.
 * @Description:
 * @Remarks:
 */
import request from './axios'
import _ from 'lodash'

const SORT_KEY = {
  '1': '', // 综合
  '2': 'newest', // 最新
  '3': 'price', // 价格从低到高
  '4': '-price' // 价格从高到低
}

export default {
  // 获取类型分类
  get1SubCateArr: topCateId => {
    return request({
      url: `order/goods/getGoodsType/${topCateId}`,
      method: 'get'
    })
  },

  getVIPGoodsList: (inf, ouf, qStr = '', currentPage, pageSize) => {
    inf = _.find(inf, {
      isSel: 1
    })
    const params = {
      areaCode: ouf.areaCateActIdx === '-1' ? '' : ouf.areaCateActIdx, // 区
      // areaCode: '110101',
      // cateId: ouf.sub1CateActIdx,
      cityCode: (!ouf.curLoc || ouf.curLoc === [] || ouf.curLoc.length === 0 || !ouf.curLoc[1]) ? '510100' : ouf.curLoc[1],
      // cityCode: '110100',
      cateId: ouf.sub1CateActIdx,
      keyword: qStr,
      // cateId: '1',
      currentPage,
      pageSize,
      sortField: SORT_KEY[inf.key],
      type: ouf.topCateActIdx || 1
      // type: '1'
    }
    return request({
      url: `order/goods/getVipOrderList`,
      method: 'get',
      params
    })
  },
  // topCateActIdx
  // sub1CateActIdx
  // areaCateActIdx
  // curLoc
  // 根据获取"商品分类"列表
  getSPFLGoodsList: (inf, ouf, qStr = '', currentPage, pageSize) => {
    inf = _.find(inf, {isSel: 1})
    const params = {
      areaCode: ouf.areaCateActIdx === '-1' ? '' : ouf.areaCateActIdx, // 区
      // areaCode: '110101',
      // cateId: ouf.sub1CateActIdx,
      cityCode: (!ouf.curLoc || ouf.curLoc === [] || ouf.curLoc.length === 0 || !ouf.curLoc[1]) ? '510100' : ouf.curLoc[1],
      // cityCode: '110100',
      cateId: ouf.sub1CateActIdx,
      keyword: qStr,
      // cateId: '1',
      currentPage,
      pageSize,
      sortField: SORT_KEY[inf.key],
      type: ouf.topCateActIdx || 1,
      isOnTrain: ouf.isOnTrain
      // type: '1'
    }
    return request({
      url: `order/goods/getCateGoodsPageData`,
      method: 'post',
      params
    })
  },

  // 获取商品详情
  getPrdDetail: goodsId => {
    return request({
      url: `order/goods/detail/${goodsId}`,
      method: 'get'
    })
  },

  // 浏览记录 lyj
  recordBrowse: params => {
    return request({
      url: '/order/goods/recordBrowse',
      method: 'post',
      params
    })
  },

  getThirdServiceUrl: goodsId => {
    return request({
      url: `order/goods/getThirdServiceUrl/${goodsId}`,
      method: 'get'
    })
  },

  // 获取商品推荐
  getRecmdByCateId: params => {
    return request({
      url: `order/goods/getCateGoodsPageData`,
      method: 'get',
      params
    })
  },

  // 商品评价
  getComments: params => {
    return request({
      url: `order/goods/getCommentPageData`,
      method: 'get',
      params
    })
  },

  // 根据推荐码获取商品的推荐信息
  getRecdInfo: p => {
    const {goodsId, code} = p
    return request({
      url: `order/goods/getRecommendGoodsInfo/${goodsId}`,
      method: 'get',
      params: {code}
    })
  },

  // 根据推荐码获取商品的推荐信息
  decideVip: goodsId => {
    return request({
      url: `order/goodsOrder/decideVip`,
      method: 'get',
      params: {goodsId}
    })
  },

  // 获取vip商品列表
  getVipOrderList: params => {
    return request({
      url: `order/goods/getVipOrderList`,
      method: 'get',
      params
    })
  },
  // 点击到主商品预览界面时，保存该点击记录
  saveClickRecord: params => {
    return request({
      url: "order/tGoods/saveGbSpdjjl",
      method: "post",
      data: params
    })
  },
  // 获取套餐分组接口
  getGoodsGroup: params => {
    return request({
      url: "/order/tGoods/getGbtczh",
      method: "post",
      data: params
    })
  },
  // 对公转账
  transferAccounts: params => {
    return request({
      url: "/order/tGoods/setDgzz",
      method: "post",
      data: {...params, isJson: true}
    })
  }

  // goodsDetailById (id) {
  //   return request({
  //     url: `/order/api/goods/getInfo/${id}`,
  //     method: 'get'
  //   })
  // }
}
